<template>
  <div>
    <z-centralized-toolbar>
      <v-toolbar-items>
        <v-btn id="btn-adicionar" text small color="primary" @click="adicionar">
          <v-icon left>mdi-tools</v-icon>Adicionar
        </v-btn>

        <v-btn
          text
          id="btn-atualizar"
          @click="refresh"
          :loading="$store.state.loading"
        >
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn-atualizar"> Atualizar </v-tooltip>
        </v-btn>
      </v-toolbar-items>

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search
        v-model="$store.state.pecas.busca"
        select
        class="ml-5"
        show-type
        @keydown.enter="buscar"
        @click:clear="limparBusca"
        @change:type="value => {$store.state.pecas.search_type = value; refresh()}"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>
        <z-cabecalho>{{ $store.state.titulo_tela }}</z-cabecalho>

        <v-card>
          <v-data-table
            mobile-breakpoint="0"
            :options.sync="$store.state.pecas.paginacao"
            :server-items-length="total_itens"
            :footer-props="$v.FOOTER_PROPS"
            :headers="headers"
            :items="pecas"
            item-key="id"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.codigo }}</td>
                <td>{{ item.referencia_fabricante }}</td>
                <td>{{ item.descricao }}</td>
                <td class="text-right">{{ item.valor_custo | valorBR }}</td>
                <td class="text-right">{{ item.valor_venda | valorBR }}</td>
                <td class="text-right">{{ item.estoque }}</td>
                <td class="text-center">
                  <v-btn icon @click="historico(item)">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn icon @click="editar(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="perguntarExcluir(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </z-container>
    </z-scroll-layout>

    <z-dialogo-sim-nao
      ref="dialogoRemoverPeca"
      titulo="Remover peça"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      A peça será removida do sistema. Deseja remover?
    </z-dialogo-sim-nao>

    <historico-peca
      ref="dialogoHistoricoPeca"
      :codigo="peca_codigo"
    ></historico-peca>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";

import HistoricoPeca from "./HistoricoPeca";

export default {
  name: "PeçasLista",

  components: {
    HistoricoPeca,
  },

  data() {
    return {
      headers: [
        { text: "Código", value: "codigo", width: "150px" },
        { text: "Referência Fab.", value: "referencia_fabricante" },
        { text: "Descrição", value: "descricao" },
        { text: "Valor Compra", value: "valor_custo", align: "right" },
        { text: "Valor Venda", value: "valor_venda", align: "right" },
        { text: "Estoque", value: "estoque", align: "right" },
        {
          text: "Opções",
          value: "",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      excluindo: false,
      peca_codigo: "",
    };
  },

  created() {
    this.refresh();
  },

  mounted() {
    this.setTitulo("Peças");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("pecas", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        console.log(error);
        this.$eventbus.notificar("Não foi possível listar os peças.");
      }
    },

    buscar() {
      this.$store.state.pecas.paginacao.page = 1;
      this.refresh();
    },

    limparBusca() {
      this.$store.state.pecas.busca = null;
      this.$store.state.pecas.paginacao.page = 1;
      this.refresh();
    },

    adicionar() {
      this.$store.commit("pecas/ZERAR");
      this.$router.push({ name: "PecasAdicionar" });
    },

    async editar(peca) {
      try {
        await this.abrir(peca.id);
        this.$router.push({ name: "PecasEditar", params: { id: peca.id } });
      } catch (error) {
        console.log(error);
        this.$eventbus.notificar("Não foi possível abrir a peça.");
      } finally {
        this.LOADING_OFF();
      }
    },

    perguntarExcluir(peca) {
      this.$refs.dialogoRemoverPeca.abrir().then(async (response) => {
        if (response == true) {
          await this.confirmarExcluir(peca);
          this.$refs.dialogoRemoverPeca.fechar();
        }
      });
    },

    async confirmarExcluir(peca) {
      try {
        this.excluindo = true;
        await this.excluir(peca.id);
        this.$eventbus.notificar("Peça excluída com sucesso!");
      } catch (error) {
        this.$eventbus.notificar("Não foi possível excluir o peça!");
        throw error;
      } finally {
        this.excluindo = false;
      }
    },

    historico(peca) {
      this.peca_codigo = peca.codigo;
      this.$refs.dialogoHistoricoPeca.abrir();
    },
  },

  computed: {
    ...mapState(["loading"]),
    ...mapState("pecas", ["pecas", "peca", "total_itens"]),

    paginacao: {
      get() {
        return this.$store.state.pecas.paginacao;
      },
      set(paginacao) {
        this.$store.commit("pecas/UPDATE_PAGINACAO", paginacao);
      },
    },
  },

  watch: {
    '$store.state.pecas.paginacao': {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
</style>
